import cx from 'classnames';
import type { FC, ReactNode } from 'react';

import ScopeCount from '@zen/Components/ScopeCount';
import { Gateway } from '@zen/DesignSystem';
import type { Undefinable } from '@zen/utils/typescript';

import { isShipmentScopeAvailable } from '../../routingHelpers';
import { scopeConfigs } from './helpers';
import type { ScopeConfig, ShipmentScopesProps } from './types';

const ShipmentScopes: FC<ShipmentScopesProps> = (props) => {
  const { activeScope, isLoading, kpiCounts, onScopeChange } = props;

  const renderScopeTile = (scopeConfig: ScopeConfig): ReactNode => {
    const { image, kpiField, label, scope } = scopeConfig;

    const isActive: boolean = scope === activeScope;
    const isAvailable: boolean = isShipmentScopeAvailable(scope);
    const isCountLoading: boolean = isLoading && !!kpiField;
    const count: Undefinable<number> = kpiField ? kpiCounts?.[kpiField] : undefined;
    const gatewayClassNames: string = cx('relative flex h-31 flex-1 min-w-0 items-end overflow-clip p-4', {
      '!border-azure-base': isActive
    });

    const selectScope = (): void => {
      onScopeChange(scope);
    };

    const handleClick: Undefinable<() => void> = isAvailable ? selectScope : undefined;

    return (
      <Gateway key={scope} className={gatewayClassNames} isDisabled={!isAvailable} onClick={handleClick}>
        <div className="flex flex-1 flex-col gap-1">
          <ScopeCount count={count} isLoading={isCountLoading} />
          <div className="text-sm font-bold leading-5 text-grey-dark">{label}</div>
        </div>
        <img alt={label} className="pointer-events-none absolute top-4 right-1.5 size-16" src={image} />
      </Gateway>
    );
  };

  return (
    <div className="flex gap-4" data-component="shipment-scopes">
      {scopeConfigs.map(renderScopeTile)}
    </div>
  );
};

export type { ShipmentScopesProps } from './types';
export default ShipmentScopes;
